<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="toc">
</a><a id="page_XIV">
<p class="center" id="map_p1">
<img alt="image" height="600" src="images/Ixiv-1.jpg" width="550"/>
</p>
<p class="series" id="map_p2">SKETCH MAP OF LAN-FANG</p>
<p class="body-text" id="map_p3">1. <i>Tribunal</i></p>
<p class="body-text" id="map_p4">2. <i>Temple of the City God</i></p>
<p class="body-text" id="map_p5">3. <i>Temple of Confucius</i></p>
<p class="body-text" id="map_p6">4. <i>Temple of the War God</i></p>
<p class="body-text" id="map_p7">5. <i>Bell Tower</i></p>
<p class="body-text" id="map_p8">6. <i>Drum Tower</i></p>
<p class="body-text" id="map_p9">7. <i>Pagoda</i></p>
<p class="body-text" id="map_p10">8. <i>Northern Row</i></p>
<p class="body-text" id="map_p11">9. <i>Southern Row</i></p>
<p class="body-text" id="map_p12">10. <i>Chien Mow’s Mansion</i></p>
<p class="body-text" id="map_p13">11. <i>General Ding’s Mansion</i></p>
<p class="body-text" id="map_p14">12. <i>Eternal Spring Wineshop</i></p>
<p class="body-text" id="map_p15">13. <i>Hermitage of the Three Treasures</i></p>
<p class="body-text" id="map_p16">14. <i>Mrs. Lee’s House</i></p>
<p class="body-text" id="map_p17">15. <i>Former Yoo Mansion</i></p>
<p class="body-text" id="map_p18">16. <i>Yoo Kee’s Mansion</i></p>
<p class="body-text" id="map_p19">17. <i>Watergate</i></p>
<p class="body-text" id="map_p20">18. <i>Execution Ground</i></p>
</a></div><a id="page_XIV">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// map.vue?392fe77b